import { render, staticRenderFns } from "./PyqPost.vue?vue&type=template&id=418aceb4&scoped=true"
import script from "./PyqPost.vue?vue&type=script&lang=js"
export * from "./PyqPost.vue?vue&type=script&lang=js"
import style0 from "./PyqPost.vue?vue&type=style&index=0&id=418aceb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418aceb4",
  null
  
)

export default component.exports